
class MetaDataBin {

	constructor(jsonData) {
		this.id = jsonData.id;
		this.name = jsonData.name;
		this.type = jsonData.type;
		this.creationTime = jsonData.creationTime;
		this.dataLength = jsonData.dataLength;
	}

}

export { MetaDataBin };